import { isAudioBufferSilent } from 'src/utils/audio';

export type AudioValidationResult = 'valid' | 'too-short' | 'silent';

const MIN_RECORDING_DURATION_SEC = 0.5;

export const validateAudioBuffer = (audioBuffer: AudioBuffer): AudioValidationResult => {
  if (audioBuffer.duration < MIN_RECORDING_DURATION_SEC) {
    return 'too-short';
  }

  if (isAudioBufferSilent(audioBuffer)) {
    return 'silent';
  }

  return 'valid';
};
